// TODO
// migrate downstreams modules to use default floating ui placement

const placementMapping = {
  'top left': 'top-start',
  'left top': 'left-start',
  'top right': 'top-end',
  'right top': 'right-start',
  'bottom left': 'bottom-start',
  'left bottom': 'left-end',
  'bottom right': 'bottom-end',
  'right bottom': 'right-end'
};
export const getFloatingUIPlacement = placement => {
  return placementMapping[placement];
};